import {
  DELETE_FILE_FAILURE,
  DELETE_FILE_REQUEST,
  DELETE_FILE_SUCCESS,
  UPLOAD_DOCUMENT_FAILURE,
  UPLOAD_DOCUMENT_MAX_FILES_FAILURE,
  UPLOAD_DOCUMENT_REQUEST,
  UPLOAD_DOCUMENT_SUCCESS,
} from 'constants/index';
import type { RootState } from 'reducers/types';
import type { Dispatch } from 'redux';
import { getCurrentLocale, isFetching } from 'selectors';
import { errorNotifier } from 'utils/errorNotifier/errorNotifier';
import { getI18nInstance } from 'utils/translations';

export const fetchUploadFileURL =
  (documentUploadURL: string) =>
  async (_dispatch: Dispatch, getState: () => RootState, { payex }: any) => {
    const state = getState();
    const locale = getCurrentLocale(state);
    const i18n = getI18nInstance(locale);

    try {
      const response = await payex.payments.fetchFileUploadURL({
        documentUploadURL,
      });

      if (!response.url) {
        throw new Error(i18n.t('documentCollector.error'));
      }

      return response.url;
    } catch (error) {
      errorNotifier.notify(error);
      throw error;
    }
  };

export const uploadFile =
  (file: File, documentUrl: string) =>
  async (dispatch: Dispatch, getState: () => RootState, { payex }: any) => {
    const state = getState();
    const isFetchingDocuments = isFetching(state, 'documents');

    if (isFetchingDocuments) {
      return;
    }

    dispatch({ type: UPLOAD_DOCUMENT_REQUEST });

    try {
      await payex.payments.uploadFileToUrl({
        file,
        url: documentUrl,
      });

      return dispatch({
        type: UPLOAD_DOCUMENT_SUCCESS,
      });
    } catch (error) {
      const { name } = file;

      errorNotifier.notify(error);

      return dispatch({
        type: UPLOAD_DOCUMENT_FAILURE,
        payload: { name },
      });
    }
  };

export const deleteFile =
  (url: string, fileId: string) =>
  async (dispatch: Dispatch, getState: () => RootState, { payex }: any) => {
    const state = getState();
    const isFetchingDocuments = isFetching(state, 'documents');

    if (isFetchingDocuments) {
      return;
    }

    dispatch({ type: DELETE_FILE_REQUEST });

    try {
      await payex.payments.deleteFile({ url });

      return dispatch({
        type: DELETE_FILE_SUCCESS,
        payload: { fileId },
      });
    } catch (error) {
      error.message = `${DELETE_FILE_FAILURE} ${error.message}`;
      errorNotifier.notifyWithFingerprint(error, [
        DELETE_FILE_FAILURE,
        error.status,
      ]);
    }
  };

export const fileNumberExceeded = () => ({
  type: UPLOAD_DOCUMENT_MAX_FILES_FAILURE,
});
